import { render, staticRenderFns } from "./TaxAssessmentDisclaimer.vue?vue&type=template&id=552ce3f5&"
import script from "./TaxAssessmentDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./TaxAssessmentDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./TaxAssessmentDisclaimer.vue?vue&type=style&index=0&id=552ce3f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports